// src/firebase.js

import { initializeApp } from 'firebase/app';
import {
  isSupported,
  getMessaging,
  getToken,
  deleteToken,
  onMessage,
} from 'firebase/messaging';

// Firebase config
const firebaseConfig = {
  apiKey: 'AIzaSyCAyUKZWtSjXdYVdw0B00MW3_k5L-xVCIE',
  authDomain: 'retrex-8a1ca.firebaseapp.com',
  projectId: 'retrex-8a1ca',
  storageBucket: 'retrex-8a1ca.appspot.com',
  messagingSenderId: '1016558743179',
  appId: '1:1016558743179:web:a2f6913b289c0edd04ae8e',
  measurementId: 'G-VFEER7S3Z6',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let messaging = null;
let messagingInitialized = false;

export async function initMessaging() {
  if (messagingInitialized) {
    return messaging;
  }

  const supported = await isSupported();

  if (!supported) {
    console.log('Firebase messaging not supported.');
    return null;
  }

  messaging = getMessaging(app);

  // notification onclick event on foreground
  onMessage(messaging, (payload) => {
    console.log('📩 Foreground FCM received:', payload);

    const { title, body, binderId, creatorId, propertyId } = payload.data || {};

    if (Notification.permission === 'granted') {
      const notification = new Notification(title || 'Notification', {
        body: body || '',
        data: {
          binderId,
          creatorId,
          propertyId,
        },
        icon:
          payload.webpush?.notification?.icon ||
          payload.data?.webpush?.notification?.icon ||
          '/firebase-logo.png',
        badge:
          payload.webpush?.notification?.badge ||
          payload.data?.webpush?.notification?.badge ||
          '/firebase-logo.png',
      });

      notification.onclick = async (event) => {
        event.preventDefault();
        console.log('🖱️ Foreground notification clicked:', event);

        try {
          const registrations =
            await navigator.serviceWorker.getRegistrations();

          const registration = registrations.find((r) =>
            r.active?.scriptURL?.includes('firebase-messaging-sw.js')
          );

          if (!registration) {
            console.warn(
              '⚠️ No active service worker found. Opening app fallback.'
            );
            window.open('/', '_blank');
            return;
          }

          const messagePayload = {
            type: 'NAVIGATE FROM FOREGROUND',
            payload: {
              title: event.currentTarget.title,
              body: event.currentTarget.body,
              binderId: event.currentTarget.data?.binderId,
              creatorId: event.currentTarget.data?.creatorId,
              propertyId: (typeof event.currentTarget.data?.transobject ===
              'string'
                ? JSON.parse(event.currentTarget.data.transobject)
                : event.currentTarget.data?.transobject || {}
              ).propertyId,
            },
          };

          if (registration.active?.postMessage) {
            registration.active.postMessage(messagePayload);
            console.log(
              '📨 Sent click event to service worker via registration.active.postMessage.'
            );
          } else if (navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage(messagePayload);
            console.log(
              '📨 Sent click event to service worker via controller.postMessage.'
            );
          } else {
            console.log('⚠️ No active service worker found. Opening app.');
            window.open('/', '_blank');
          }
        } catch (error) {
          console.error(
            '❌ Error handling foreground notification click:',
            error
          );
        }

        notification.close();
      };
    }
  });

  messagingInitialized = true;

  return messaging;
}

const generateToken = async () => {
  try {
    const msg = await initMessaging();

    if (!msg) {
      return null;
    }

    // Check current permission first
    let permission = Notification.permission;

    // Only request permission when it is still undecided.
    // This function should be called from a user click in that case.
    if (permission === 'default') {
      console.log('🔔 Notification permission has not been decided yet.');
      return null;
    }

    if (permission !== 'granted') {
      console.warn('⚠️ Notification permission not granted.');
      return null;
    }

    let registration;

    const existingRegs = await navigator.serviceWorker.getRegistrations();

    registration = existingRegs.find((r) =>
      r.active?.scriptURL.includes('firebase-messaging-sw.js')
    );

    if (!registration) {
      console.log('🆕 Registering new service worker...');

      registration = await navigator.serviceWorker.register(
        `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`
      );
    } else {
      console.log('✅ Existing service worker found.');
    }

    if (!registration.active) {
      console.log('⏳ Waiting for service worker to activate...');

      await new Promise((resolve) => {
        const checkActive = setInterval(() => {
          if (registration.active) {
            clearInterval(checkActive);
            resolve();
          }
        }, 500);
      });
    }

    console.log('🟢 Service worker active, getting FCM token...');

    const currentToken = await getToken(msg, {
      vapidKey:
        'BGi4g_XsPpQJj-kGE8MV3fnDMl_8TgTHixBEHxo-s9rkHJpvxuRM9FN-qNxVr2__vYxAcI91ERPEhfRJJJ1avTY',
      serviceWorkerRegistration: registration,
    });

    if (currentToken) {
      console.log('✅ FCM Token:', currentToken);
      sessionStorage.setItem('FCMTOKEN', currentToken);
      return currentToken;
    }

    console.warn('⚠️ No FCM token returned.');
    return null;
  } catch (error) {
    console.error('❌ Error generating FCM token:', error);
    return null;
  }
};

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();

    console.log('🔔 Notification permission:', permission);

    if (permission !== 'granted') {
      console.warn('⚠️ Notification permission not granted.');
      return null;
    }

    return await generateToken();
  } catch (error) {
    console.error('❌ Error requesting notification permission:', error);
    return null;
  }
};

// Unregister token
const unregisterFCM = async () => {
  try {
    if (!messaging) return;

    const success = await deleteToken(messaging);

    console.log('FCM token unregistered:', success);
  } catch (err) {
    console.error('Error unregistering token:', err);
  }
};

export { messaging, generateToken, unregisterFCM };
